module.exports = __webpack_public_path__ + "static/media/DBKFoundryWorkshopA0009_design_clean_v002.ae085942.webp";